import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import '../../styles/Curation.css';
import usePageTitle from '../../utils/use-page-title';
import Can from '../auth/Can';
import Unauthorized from '../auth/Unauthorized';
import { AuthConsumer } from '../auth/AuthContext';
import Protected from '../auth/Protected';
import ContextProvider from './CurationContext';
import CarouselContainer from './CarouselContainer';
import ActionBar from './ActionBar';
import ModeBar from './ModeBar';
import NewCurationItem from './NewCurationItem';
import EditCurationItem from './EditCurationItem';

const Curation = () => {
  usePageTitle('Curations');
  const [showNewCurationItem, setShowNewCurationItem] = useState(false);
  const [showEditCurationItem, setShowEditCurationItem] = useState(false);

  const renderCuration = () => (
    <div className="Curation-container">
      <Container>
        <ModeBar />
        <hr />
        <Row>
          <Col>
            <CarouselContainer
              onNewCurationItemClick={() => setShowNewCurationItem(true)}
              onEditCurationItemClick={() => setShowEditCurationItem(true)}
            />
          </Col>
        </Row>
        <hr />
        <Protected privilege="curation:publish">
          <ActionBar />
        </Protected>
      </Container>
      {showNewCurationItem && <NewCurationItem />}
      {showEditCurationItem && <EditCurationItem />}
    </div>
  );

  return (
    <ContextProvider>
      <AuthConsumer>
        {({ user }) => (
          <Can
            role={user.role}
            perform="curation:view"
            yes={renderCuration}
            no={() => <Unauthorized />}
          />
        )}
      </AuthConsumer>
    </ContextProvider>
  );
};

export default Curation;
